/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outside_BodyInputs */

const en_outside_body = /** @type {(inputs: Outside_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexxt talks to Business Central, the IMS, the warehouse, Joor and Zendesk through one integration layer, TIL. Every message leaves from an outbox and comes back with a receipt: nothing is lost, nothing is sent twice.`)
};

/**
* | output |
* | --- |
* | "Nexxt talks to Business Central, the IMS, the warehouse, Joor and Zendesk through one integration layer, TIL. Every message leaves from an outbox and comes b..." |
*
* @param {Outside_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const outside_body = /** @type {((inputs?: Outside_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outside_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outside_body(inputs)
});